import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=c68aa7e4&scoped=true&"
import script from "./EditProfile.vue?vue&type=script&lang=js&"
export * from "./EditProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=c68aa7e4&prod&scoped=true&lang=css&"
import style1 from "./EditProfile.vue?vue&type=style&index=1&id=c68aa7e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68aa7e4",
  null
  
)

export default component.exports